import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";

const EditButton = (props) => {
  const { id } = props;
  const history = useHistory();
  return (
    <>
      <button
        className="btn btn-light shadow-sm"
        style={{
          fontSize: "14px",
          color: "rgb(227, 156, 72)",
          backgroundColor: "rgb(255,255,255)",
          paddingTop: "6px",
          paddingBottom: "3px",
          marginTop: "0px",
          marginBottom: "0px",
          paddingRight: "2px",
          paddingLeft: "1px",
          width: "76px",
          borderRadius: 0,
          fontFamily: "emoji",
          fontWeight: "700",
        }}
        onClick={() =>
          history.push(
            `/auction_representative/user_home/manage-ta-onboard/update-ta-user:${id}`
          )
        }
      >
        <FontAwesomeIcon
          icon={faPenToSquare}
          style={{ fontWeight: 200, marginRight: "2px" }}
        />
        Edit
      </button>
    </>
  );
};

export default EditButton;
